import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { LinkButton, Button } from '~/lib/ui/button'
import { useBenefits } from '../BenefitsProvider'
import { useTranslation } from '~/hooks/useTranslation'

const NetworkingStrategyDialog = ({ buttonUrl }) => {
  const [open, setOpen] = useState(false)
  const {
    current_user: {
      candidate_first_name: candidateFirstName,
      completed_services: completedServices,
    } = {},
  } = useBenefits()
  const { t } = useTranslation(
    'ProfessionalServices.NetworkingStrategy.NetworkingStrategyDialog',
  )

  const jobSearchStrategyCompleted =
    completedServices?.includes('JobSearchStrategy')
  const linkedInProfileOptimizationCompleted = completedServices?.includes(
    'LinkedInProfileOptimization',
  )
  const skipPrompt =
    jobSearchStrategyCompleted && linkedInProfileOptimizationCompleted

  const onOpenChange = (isOpen) => {
    if (isOpen && skipPrompt) {
      window.location.href = buttonUrl
    } else {
      setOpen(isOpen)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange} className="rounded-2xl">
      <DialogTrigger asChild className="cursor-pointer">
        <Button variant="coachcta">{t('get_started')}</Button>
      </DialogTrigger>
      <DialogContent className="md:max-w-[50.5rem]">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            {t('best_practices')}
          </DialogTitle>
        </DialogHeader>
        <div className="mx-4 mb-4">
          <p>{t('greeting', { firstName: candidateFirstName })}</p>
          <p>{t('content')}</p>
          <div className="mt-6 flex flex-col justify-evenly gap-2 md:flex-row md:flex-wrap">
            <LinkButton
              variant="outline"
              href="/coach_services/professional_services/job_search_strategy"
            >
              {t('actions.job_search_strategy')}
            </LinkButton>
            <LinkButton
              variant="outline"
              href="/coach_services/professional_services/linked_in_review"
            >
              {t('actions.linkedin_profile_optimization')}
            </LinkButton>
            <LinkButton href={buttonUrl}>
              {t('actions.continue_anyways')}
            </LinkButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default NetworkingStrategyDialog
